<app-base-modal
  variant="default"
  [title]="data.title || 'edit your card'"
  (closed)="close()"
>
  <form [formGroup]="editCardForm">
    <p class="section-label">Front of Card</p>

    <div class="field">
      <label class="field-label" for="card-type">Card type</label>
      <div id="card-type" class="pill-input card-type-pill" [ngClass]="cardTypeCssClass">
        {{ cardTypeLabel }}
      </div>
    </div>

    <div class="field">
      <label class="field-label" for="card-name">Card name*</label>
      <input
        id="card-name"
        class="pill-input"
        type="text"
        formControlName="cardName"
        placeholder="e.g. mindfulness breathing exercise"
        autocomplete="off"
      />
      <app-error-display
        *ngIf="editCardForm.get('cardName')?.hasError('duplicateName')"
        errorMessage="{{ duplicateNameMessage }}"
        [displayVariant]="'dialog'"
      ></app-error-display>
    </div>

    <div class="field">
      <label class="field-label" for="card-duration">Duration (minutes)</label>
      <select id="card-duration" class="pill-input pill-select" formControlName="periodMinutes">
        <option [ngValue]="null">None</option>
        <option *ngFor="let opt of numberOptions" [ngValue]="opt">{{ opt }}</option>
      </select>
      <span class="field-error" *ngIf="editCardForm.get('periodMinutes')?.invalid">
        Time must be between 1 and 60 minutes
      </span>
    </div>

    <p class="section-label">Back of Card</p>

    <div class="field">
      <textarea
        class="pill-textarea"
        formControlName="description"
        placeholder="Flip side of text"
        rows="4"
        maxlength="200"
      ></textarea>
    </div>
  </form>

  <div actions class="actions">
    <button type="button" class="action-pill cancel" (click)="close()">Cancel</button>
    <button type="button" class="action-pill save" [disabled]="editCardForm.invalid" (click)="save()">Save</button>
  </div>
</app-base-modal>
